export default __webpack_public_path__ + "static/hotblack-events1-c30aacd0429eaeba560f5c0026e41ffb.jpg";